<mat-card class="container">
  <mat-card-title>{{ 'thank-you.header' | transloco }}</mat-card-title>
  <mat-card-content>{{ 'thank-you.content' | transloco }}</mat-card-content
  ><mat-card-footer>{{ 'thank-you.footer' | transloco }}</mat-card-footer>
</mat-card>
